/**
 * 配置说明
 * title: 钱包协议
 */
export default [
  {
    name: 'wallet',
    path: '/wallet',
    component: () => import('@/views/wallet/index'),
    meta: { title: '充值服务协议' },
  },
];
